import { Label, Value } from "./styles";

type Props = {
  label: string;
  value: string;
};

const Parameter: React.FC<Props> = (props) => {
  const { value, label } = props;
  return (
    <>
      <Label as="span">{label}</Label>
      <Value as="span">{value}</Value>
    </>
  );
};

export default Parameter;
